import { useEffect, useState } from "react";
import Header from "../Component/Header";
import Footer from "../Component/Footer";
import Breadcrumb from "../Component/Breadcrumb";
import LazyLoad from "react-lazyload";
import { getFaculty } from "../Service/Api";

const SchoolManagement = () => {
  const [managementData, setManagementData] = useState([]);

  const getFacultyImage = (item) => {
    const baseUrl = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/";
    const fallbackImage = "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/AFGJI/public/Images/dummy_img.png";
    const attachments = item?.attachments;
    const getFullUrl = (value) => {
      if (!value || typeof value !== "string") return fallbackImage;
      const trimmedValue = value.trim();
      if (!trimmedValue) return fallbackImage;
      if (/^https?:\/\//i.test(trimmedValue)) return trimmedValue;
      return `${baseUrl}${trimmedValue.replace(/^\/+/, "")}`;
    };

    if (!Array.isArray(attachments) || attachments.length === 0) {
      return fallbackImage;
    }

    const firstAttachment = attachments[0];

    if (typeof firstAttachment === "string" && firstAttachment.trim()) {
      return getFullUrl(firstAttachment);
    }

    if (typeof firstAttachment === "object" && firstAttachment !== null) {
      return getFullUrl(
        firstAttachment.url ||
        firstAttachment.path ||
        firstAttachment.location
      );
    }

    return fallbackImage;
  };

  useEffect(() => {
    const fetchManagementData = async () => {
      const data = await getFaculty();
      const filteredManagement = (Array.isArray(data) ? data : [])
        .filter((item) => item?.category === "Management")
        .sort((a, b) => parseInt(a?.order || 0, 10) - parseInt(b?.order || 0, 10));

      setManagementData(filteredManagement);
    };

    fetchManagementData();
  }, []);

  return (
    <>
      <Header />
      <Breadcrumb pageTitle="Management" breadcrumbName="Management" />

      <div className="container body_height">
        <div className="row">
          <div className="row">
            {managementData.length > 0 ? (
              managementData.map((item, index) => (
                <div className="col-md-6" key={`${item?.name || "management"}-${index}`}>
                  <div className="team">
                    <div className="col-xs-12 col-sm-12 col-md-12">
                      <LazyLoad>
                        <img
                          src={getFacultyImage(item)}
                          className="img-responsive img-circle center-block"
                          alt={item?.name || "AFGJI"}
                        />
                      </LazyLoad>
                    </div>
                    <div className="col-xs-12 col-sm-12 col-md-12">
                      <center>
                        <h5>{item?.name || "-"}</h5>
                        <h6>
                          <strong>{item?.qualification || "-"}</strong>
                          <br />
                          {item?.designation || "-"}
                        </h6>
                      </center>
                    </div>
                  </div>
                </div>
              ))
            ) : (
              <div className="col-md-6">
                <div className="team">
                  <div className="col-xs-12 col-sm-12 col-md-12">
                    <LazyLoad>
                      <img
                        src="https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/AFGJI/public/Images/dummy_img.png"
                        className="img-responsive img-circle center-block"
                        alt="No management"
                      />
                    </LazyLoad>
                  </div>
                  <div className="col-xs-12 col-sm-12 col-md-12">
                    <center>
                      <h5>-</h5>
                      <h6>
                        <strong>-</strong>
                        <br />
                        -
                      </h6>
                    </center>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SchoolManagement;
